module.exports = __webpack_public_path__ + "img/terracenew_box13.50972536.jpg";